import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode");
  if (codeEntite) {
    config.headers["ref_entity"] = `client_${codeEntite}`;
  } else {
    config.headers["ref_entity"] = null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeServicePagination = async (page, size) => {
  return await axios.get(
    BASE_URL(`admin/listeservices?page=${page}&size=${size}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeServiceEtablissement = async () => {
  return await axios.get(BASE_URL(`etablissement/listeservices`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getListeDesTarifsEnregistre = async (
  page,
  size,
  param = "",
  annee = "",
  niveau = "",
  service = ""
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/listedestarifs?anneeId=${annee}&niveauId=${niveau}&page=${page}&param=${param}&serviceMoMoId=${service}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const enregistrementTarifService = async (values) => {
  return await axios.post(BASE_URL(`etablissement/enregistrertarif`), values, {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const supprimerTarifService = async (values) => {
  return await axios.post(BASE_URL(`etablissement/supprimertarif`), values, {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getListeDesModaliteEnregistre = async (
  page,
  size,
  niveau = "",
  annee = "",
  service = ""
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/listedesmodalites?anneeId=${annee}&niveauId=${niveau}&page=${page}&serviceId=${service}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const enregistrementModalitePaiement = async (values) => {
  return await axios.post(
    BASE_URL(`etablissement/enregistrermodalite`),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const supprimerModalitePaiement = async (id) => {
  return await axios.delete(BASE_URL(`etablissement/supprimermodalite/${id}`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};
